import luaApi from "./api/luaApi";
import {
    createSinglePromise,
} from "./utils/loadResources";
// 内存缓存
const CACHE = {
    projectContexts:{},
};

/**
 * 项目编码转换为可访问的上下文路径
 * @param projectName 项目编码
 * 例如：
 * 1对1场景：
 *      projectName:'iuap-dcpipeline-fe' ==》 '/iuap-dcpipeline/ucf-wh/'
 * N对1场景：
 *      projectName:'iuap-data-ep.mobile-fe' ==》 '/iuap-data-ep/ucf-wh/mobile/'
 */
export const projectName2ContextPath = (projectName) => {
    if(!projectName)return;
    const tagPath = "ucf-wh";//规范标识路径名
    let temp = projectName.endsWith("-fe")?projectName.substring(0, projectName.length - 3): projectName;//去除"-fe"结尾  截取后三位
    let contextPath = temp.lastIndexOf('.')>-1?`/${temp}/`.replace('.','/'+tagPath+'/'):`/${temp}/${tagPath}/`;//访问url的上下文
    return contextPath;
} 
export const asyncUrl2ProjectName = async(url, originProjects) => {
    if (!url || !url.includes('/ucf-wh/')) {
        return ''
    }
    const [leftUrl, rightUrl] = url.split('/ucf-wh/');
    const left = leftUrl.match(/[\w-]*\w+$/)?.[0]; // todo 正则 需要进一步场景
    const right = rightUrl.match(/^[\w-]*\w+/)?.[0]; // todo 正则 需要进一步场景
    const mergeProjectName = `${left}`;
    const mergeProjectName2 = `${left}-fe`;
    const mergeProjectName3 = `${left}.${right}-fe`;
    const mergeProjectName4 = `${left}.${right}`;
    // const projects = await luaApi.asyncFetchProjectVersions();
    let projects = {};
    // 兼容社会化引用
    if(originProjects){
        projects = originProjects;
    }else{
        projects  = await luaApi.asyncFetchAllProjects();
    }
    if (!projects) {
        return ""
    }
    let projectName = "";

    // 优先找微服务编码带.的
    switch (true) {
        case !!projects[mergeProjectName3]:
            projectName = mergeProjectName3;
            break;
        case !!projects[mergeProjectName4]:
            projectName = mergeProjectName4;
            break;
        case !!projects[mergeProjectName]:
            projectName = mergeProjectName;
            break;
        case !!projects[mergeProjectName2]:
            projectName = mergeProjectName2;
            break;
        default:
            break;
    }
    return projectName;
}


// 获取指定项目的上下文信息
export async function asyncProjectContext(projectName){
    let isOffline = window.location.origin.startsWith("file://");
    if(CACHE.projectContexts[projectName]){
        return Object.assign({},CACHE.projectContexts[projectName]); //注意返回副本
    }
    let pjtContextPath = projectName2ContextPath(projectName);
    // 获取项目当前版本号
    let fetchUrl = pjtContextPath+"version.json";
    if (window.TNS_BASE_HOST) {
        fetchUrl = window.TNS_BASE_HOST + fetchUrl;
    } else {
        if (isOffline && window.TNS_OFFLINE_HOST) {
            fetchUrl = window.TNS_OFFLINE_HOST + fetchUrl;
        }
    }
    let respJson = await asyncFetchUrlGetVersion(fetchUrl);
    let pjtVersion = respJson.version;
    // 获取全局上下文
    let context = await luaApi.asyncFetchContext();
    let projectUrl = '';
    // 存在cdnHost则使用cdn域名否则使用相对域名加载资源
    if(context.cdnHost){
        projectUrl = `${context.cdnHost}/static/ucf/${projectName}/${pjtVersion}/`;
    }else if(isOffline && window.TNS_OFFLINE_HOST){
        projectUrl = window.TNS_OFFLINE_HOST + pjtContextPath;
    }else{
        projectUrl = pjtContextPath;
        if(window.TNS_BASE_HOST){
            projectUrl = window.TNS_BASE_HOST + projectUrl;
        }
    }
    // 返回的项目上下文
    let projectContext = {
        projectName:projectName,
        projectContextPath:pjtContextPath,
        projectVersion:pjtVersion,
        projectRootUrl:projectUrl,
        envCode:context.envCode
    }
    CACHE.projectContexts[projectName] = projectContext;
    return projectContext;
}

// 确保并发情况下相同请求生效同一个promise
async function asyncFetchUrlGetVersion(fetchUrl){
    return await createSinglePromise("asyncProjectContext" + fetchUrl, async()=>{
        let fetchResp = await fetch(fetchUrl);
        try{
             let respJson = await fetchResp.json();
            return respJson;
        }catch(e){
            console.warn(`[TNS]获取项目版本信息失败，${fetchUrl}`);
            return {};
        }
    });
}
